<script lang="ts">
  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()
</script>

{#if course_progress.substep === 1}
  <p class="text-center text-3xl font-bold">Module 2: Brand Purpose</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      By going through this module, you will better understand What a Brand
      Purpose is, Why it is Important, and the steps you need to follow to
      create your own. I share examples for you to look at and then you Do The
      Work and craft your own inspiring Brand Purpose which you will enter
      online into your One Page Alignment Plan.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083502"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 2}
  <p class="text-center text-3xl font-bold">2.1 What is a Brand Purpose?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I teach you the definition of a Brand Purpose and share with you three
      examples for very well-known companies.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083546"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 3}
  <p class="text-center text-3xl font-bold">2.3 Why is it Important?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you why a brand purpose is important and the impact it will
      have engaging you, your employees and your customers.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083591"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 4}
  <p class="text-center text-3xl font-bold">2.4 How to Craft</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I teach you the process you need to follow to craft your Brand Purpose,
      which is also detailed in the Brand Purpose Chapter provided. I share with
      you the five questions you need to answer to help you start thinking about
      your brand purpose and how employee and customer surveys can give you
      valuable insights. I walk you through the “Why Does It Matter” exercise.
    </p>
    <p class="mt-6 text-lg">
      Once you think you have your Brand Purpose, I show you the five questions
      you need to answer to make sure it is inspiring and impactful. To close
      this video, I walk you through how the YWCA developed their brand purpose
      of “Transforming Lives Together.”
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083634"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 5}
  <p class="text-center text-3xl font-bold">2.5 Flint Inc. Brand Purpose</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you how the President of Flint Inc. followed the process and
      used the “Why Does It Matter” exercise to create his company's inspiring
      Brand Purpose.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083680"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 6}
  <p class="text-center text-3xl font-bold">2.6 Do the Work</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      This module is focused on having you craft your company's inspiring Brand
      Purpose.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083719"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 7}
  <p class="text-center text-3xl font-bold">2.7 Wrap Up</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I ask you to reflect upon the Brand Purpose module. I end
      the video by giving you a brief overview of the next values module.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083760"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{/if}
